export function playErrorBeep() {
  try {
    const audio = new Audio('/sounds/error.mp3'); // public/sounds/error.mp3 altında olsun
    // eslint-disable-next-line no-console
    audio.play().catch((err) => console.error('Error playing sound:', err));
  } catch {
    // eslint-disable-next-line no-console
    console.error('Error playing sound');
  }
}

export function playScanSuccess() {
  try {
    const ctx = new (window.AudioContext ||
      (window as any).webkitAudioContext)();

    const osc = ctx.createOscillator();
    osc.type = 'square'; // daha "elektronik" bip
    osc.frequency.setValueAtTime(1050, ctx.currentTime);

    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.4, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start();
    osc.stop(ctx.currentTime + 0.15);
  } catch {
    // eslint-disable-next-line no-console
    console.error('Error playing sound');
  }
}
